<template>
  <div>
    <el-container>
      <el-header>
        <el-breadcrumb separator-class="el-icon-arrow-right">
          <el-breadcrumb-item :to="{ path: '/' }">首页</el-breadcrumb-item>
          <el-breadcrumb-item>数据中心</el-breadcrumb-item>
          <el-breadcrumb-item>营运商电损比管理</el-breadcrumb-item>
        </el-breadcrumb>
      </el-header>
    </el-container>
    <el-main>
      <el-row>
        <el-col :span="24">
          <el-tabs v-model="activeName" type="border-card">
            <el-tab-pane label="电损比管理" name="typeList">
              <el-row v-show="showFilters">
                <search :stations="stations" :searchForm="searchForm" :listForSelectTree="listForSelectTree"
                  :searchLoading="searchLoading" @submitSearchForm="submitSearchForm" @changeOpertorId="changeOpertorId"
                  @add="add"></search>

                <list :dataTable="dataTable" :listLoading="listLoading" @handleSelectionChange="handleSelectionChange"
                  @insertOrUpdate="insertOrUpdate" @deletes="deletes">
                </list>
                <el-pagination @size-change="handleSizeChange" @current-change="handleCurrentChange"
                  :current-page="this.pageparm.currentPage" :page-size="10" layout="total, sizes, prev, pager,
                  next, jumper" :total="this.pageparm.total"></el-pagination>
                <add :tit="tit" :editForm="editForm" :stations="stations" :listForSelectTree="listForSelectTree"
                  :editFormVisible="editFormVisible" :editSubmitLoading="editSubmitLoading"
                  @changeOpertorIds="changeOpertorIds" @editSubmit="editSubmit" @closeEditForm="closeEditForm"
                  @change="change"></add>
              </el-row>
            </el-tab-pane>
          </el-tabs>
        </el-col>
      </el-row>
    </el-main>
  </div>
</template>

<script>
  import stationPercentageManager from '@/module/dataCenter/api/stationPercentageManager.js'
  import list from './stationPercentage/list.vue'
  import add from './stationPercentage/add.vue'
  import configApi from '@/module/resourceCenter/api/meterConfigurationApi'
  import search from './stationPercentage/search.vue'
  export default {
    name: 'stationPercentageManager',
    data() {
      return {
        enumData: [{
          operatorTypeData: "",
          payTypeData: ""
        }],
        stationsForSelect: '',
        operatorForSelect: [],
        pilesForSelect: '',
        activeName: 'typeList',
        showFilters: true,
        listLoading: false,
        simCardDataTable: [{}],
        dataTable: [{}],
        exportLoading: false,
        // 多选集合
        simCardDataSelection: [],

        obj: {},
        // 查询
        searchLoading: false,
        searchFormVisible: false,
        stations: [],
        aliPays: "",
        searchForm: { // 未初始化不传递参数，影响后台接查询
        },

        tit: "",
        payQrCode: "",

        loading: false,
        listForSelectTree: [{}],
        addOrEditFrom: {},
        addOrEditFromLoading: false,
        // 编辑
        editFormVisible: false,
        editSubmitLoading: false,
        editForm: {

        },
        // 详情
        detailFormVisible: false,
        detailForm: {},
        simCardsPays: [],

        // 分页参数
        pageparm: {
          t: {},
          currentPage: 1,
          pageSize: 10,
          total: 0
        },
        selectable: false,
        activeNames: ['basicInformation']
      }
    },
    methods: {
      submitSearchForm() {
        this.getdate();
      },
      handleSelectionChange(val) {
        this.simCardsPays = val

      },
      add() {
        this.tit = "新增"
        this.editFormVisible = true
        this.clearForm()
      },
      //每页条数修改
      handleSizeChange(val) {
        this.pageparm.pageSize = val
        console.log(val)
        this.searchForm.id = this.value1
        this.getdate();
      },
      clearForm() {
        for (let item in this.editForm) {
          if (this.editForm[item]) {
            this.editForm[item] = ''
          }
        }

      },
      closeDialog() {
        this.editFormVisible = false
        this.getdate()

      },
      changeOpertorIds(){
        this.$forceUpdate()
        let par = []

        if (this.editForm.operatorId != null && this.editForm.operatorId != '') {
          par.push(this.editForm.operatorId);
        } else {
          this.stations = []
          this.editForm.stationId = ''
        }
        console.log(par)
        this.getstationData(par)
      },
      addDate() {
        let nowDate = new Date();
        let date = {
          year: nowDate.getFullYear(),
          month: nowDate.getMonth() + 1,
          date: nowDate.getDate(),
        }
        console.log(date);
        let systemDate = date.year.toString() + date.month.toString() + date.date.toString();
        return systemDate
      },
      closeEditForm() {
        this.editFormVisible = false
        this.clearForm()
      },
      simCardLogPayWexin(row, val) {
        this.simCardLogPayAli(row, val)
      },
      // 获取当前日期的方法
      getTime() {
        setInterval(() => {
          //new Date() new一个data对象，当前日期和时间
          //toLocaleString() 方法可根据本地时间把 Date 对象转换为字符串，并返回结果。
          this.nowtime = new Date().toLocaleString();
        }, 1000)
      },


      //页码变化
      handleCurrentChange(val) {
        this.pageparm.currentPage = val
        this.searchForm.id = this.value1
        this.getdate();
      },
      getlistForSelectTree() {
        let param = {};
        configApi.getlistForSelectTree(param).then((res) => {
          if (res.code === 0) {
            this.listForSelectTree = res.data
          }
        })
      },
      insertOrUpdate(row) {
        this.editFormVisible = true
        this.editForm.operatorId = row.operatorId
        if (row.operatorId != null > 0) {
             this.changeOpertorIds()
        }
        this.editForm.stationId = row.stationId
        this.editForm.percentage = row.percentage
        this.editForm.id = row.id
      },

      editSubmit(row) {

        if (this.editForm.stationId != null) {
           let addOrEditForm = Object.assign({}, this.editForm)
           addOrEditForm.percentage=''
          stationPercentageManager.getStationPercentage(addOrEditForm)
            .then(res => {
              if (res||this.editForm.id!=null) {
                row.validate((valid) => {

                  if (valid) {
                    this.$confirm('确定要提交吗?', '信息', {
                        confirmButtonText: '确定',
                        cancelButtonText: '取消',
                        type: 'warning'
                      })
                      .then(() => {

                        stationPercentageManager.insertOrUpdate(this.editForm)
                          .then(res => {
                            if (res.code === 0) {
                              this.$message({
                                type: 'success',
                                message: '数据已提交'
                              })


                              this.getdate()

                              this.closeEditForm();
                            } else {
                              this.$message({
                                type: 'info',
                                message: res.data.msg
                              })

                              this.closeEditForm();
                            }
                          })
                          .catch(err => {
                            this.loading = false
                            console.log(this.addOrEditForm)
                            this.closeEditForm();

                            this.getdate()
                            this.$message.error('数据提交失败，该电桩已经绑定了电表！')
                          })
                      })
                    // 向后台发送请求
                  } else {
                    this.$message('请填写相关内容');

                    //就像用户提示发生错误的消息
                  }
                })
              }else{
                this.$message('当前站点已经有了电损比');

              }

            })
        }

      },
      change() {
        this.$forceUpdate()
      },
      deletes(row) {
        console.log(row)
        this.loading = true
        this.$confirm('确定要删除吗?', '信息', {
            confirmButtonText: '确定',
            cancelButtonText: '取消',
            type: 'warning'
          })
          .then(() => {

            stationPercentageManager.delete(row.id).then(res => {
                if (res.code === 0) {
                  this.$message({
                    type: 'success',
                    message: '数据已删除!'
                  })


                  this.getdate()
                } else {
                  this.$message({
                    type: 'info',
                    message: res.msg
                  })
                }
              })
              .catch(err => {
                this.loading = false
                this.$message.error('数据删除失败，请稍后再试！')
              })
          })
      },
      changeOpertorId() {
        this.$forceUpdate()
        let par = []

        if (this.searchForm.operatorId != null && this.searchForm.operatorId != '') {
          par.push(this.searchForm.operatorId);
        } else {
          this.stations = []
          this.searchForm.stationId = ''
        }

        this.getstationData(par)
      },
      getstationData(param) {
        configApi.alarmStationAll(param).then((res) => {
          console.info(JSON.stringify(res.data))
          this.stations = res.data
        })
      },
      simCardLogPay() {},
      getdate() {
        this.listLoading = true
        this.searchLoading = true
        // let param = Object.assign({}, this.stationSearchForm)
        // para.date = (!para.date || para.date == '') ? '' : util.formatDate.format(new Date(para.date), 'yyyy-MM-dd');

        this.pageparm.t = this.searchForm
        let param = Object.assign({}, this.pageparm)
        console.log(param)
        stationPercentageManager.getStationPercentagePage(param).then((res) => {
          if (res.code === 0) {

            this.dataTable = res.data.list
            this.pageparm.total = res.data.total

            // this.$message({
            //   message: res.message,
            //   type: 'success'
            // })
          } else {
            this.$message.error(res.message)
          }
          this.listLoading = false
          this.searchLoading = false
          this.editFormVisible = false
        })
      }
    },
    handleClick() {},
    components: {
      // Pagination,
      search,
      list,
      add,
      // detail
    },

    created() {
      // console.log(this.closeDialog())
    },
    mounted: function() {
      this.getlistForSelectTree()
      this.getdate()
    }
  }
</script>

<style>
</style>



// WEBPACK FOOTER //
// src/module/dataCenter/page/stationPercentageManager.vue